


type FormatDelta<T extends {}> = Map<T, T>

export function Formatter<T extends {}>(hashFn: (obj: T) => string, combineFn: (obj1: T, obj2: T) => T) {


    const map = new Map<T, Map<T, T>>();
    const dict: { [k: string]: T } = {};
    function define(obj: T): T
    function define(obj: undefined): undefined
    function define(obj: T | undefined) {
        if (!obj || map.has(obj))
            return obj;
        const hash = hashFn(obj);
        if (hash in dict)
            return dict[hash]
        dict[hash] = obj;
        map.set(obj, new Map<T, T>())
        return obj;
    }
    let obj: T

    function combine(obj1: T, obj2?: T): T
    function combine(obj1: undefined, obj2: T): T
    function combine(obj1: undefined, obj2: undefined): undefined
    function combine(obj1: T | undefined, obj2?: T): T | undefined {
        if (obj1 === undefined && obj2 === undefined) return undefined
        if (obj1 === undefined) return define(obj2 as T)
        if (obj2 === undefined) return define(obj1 as T)
        const o1 = define(obj1)
        const o2 = define(obj2)
        if (o1 === o2)
            return o1;
        const delta = map.get(o1) as FormatDelta<T>
        const o = delta.get(o2)
        if (o !== undefined)
            return o
        const o3 = define(combineFn(o1, o2))
        delta.set(o2, o3);
        return o3;

    }

    return {
        define,
        combine,
        list: () => Array.from(map.keys()),
        [Symbol.iterator]() { return map.keys() }
    }
}




